import React, { Component } from 'react';
export class FAQLink extends Component {
    render() {
        return(
            <a id="faqLink" onClick={this.props.showFAQ}><i className="icon-help icon"></i>FAQs</a>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/FAQLink.jsx